import type { SVGProps } from 'react';
const DawnFlagPF = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <path
      fill="#fff"
      d="M0 2a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
    />
    <path
      fill="#F5F5F5"
      fillRule="evenodd"
      d="M20 .5H2A1.5 1.5 0 0 0 .5 2v12A1.5 1.5 0 0 0 2 15.5h18a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 20 .5M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"
      clipRule="evenodd"
    />
    <mask
      id="dawn-flag-PF_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g mask="url(#dawn-flag-PF_svg__a)">
      <path
        fill="#D82332"
        fillRule="evenodd"
        d="M0 4.267h22V0H0zM0 16h22v-4.267H0z"
        clipRule="evenodd"
      />
      <path
        fill="#064A89"
        fillRule="evenodd"
        d="m10.267 8.602-.223.212c.202.058.482-.01.594-.212zM8.464 8.747c.151.154.402.136.553.038a.5.5 0 0 1 .357-.093c.01.086.032.198.07.308h-.897a3 3 0 0 1-.083-.253M8.63 9.158a.43.43 0 0 1 .434.044c.144.113.381.082.498.018a.8.8 0 0 0 .164.202h-.96a2 2 0 0 1-.136-.264M12.806 9.86c.042-.044.099-.116.136-.167-.062-.008-.134-.053-.21-.092-.142-.072-.277-.072-.397.013-.179.125-.402.156-.576.03-.19-.138-.367-.107-.516-.02a.58.58 0 0 1-.332.092.58.58 0 0 1-.332-.092c-.15-.087-.326-.118-.516.02-.174.126-.397.095-.575-.03-.12-.085-.256-.085-.397-.013-.077.039-.15.084-.211.092.037.051.094.123.136.167zM12.341 10.289c.04-.026.15-.11.204-.154-.06.013-.195-.032-.266-.07-.203-.107-.337-.097-.488-.015-.152.082-.365.126-.521.039a.7.7 0 0 0-.35-.11.7.7 0 0 0-.35.11c-.156.087-.369.043-.52-.039s-.285-.092-.489.016c-.07.037-.206.082-.265.07.054.043.164.127.203.153zM11.446 9.436a.45.45 0 0 1-.136-.146c-.072-.11-.186-.172-.358-.172-.17 0-.285.062-.357.172a.45.45 0 0 1-.136.146zM11.165 9.04a1 1 0 0 1-.067-.18.7.7 0 0 1-.16.018.7.7 0 0 1-.162-.018c-.012.051-.05.149-.067.18zM11.578 8.602l.224.212c-.202.058-.482-.01-.594-.212zM13.435 8.747c-.15.154-.401.136-.553.038a.5.5 0 0 0-.356-.093c-.01.086-.033.198-.07.308h.896c.023-.056.066-.188.083-.253M13.3 9.158a.43.43 0 0 0-.433.044c-.144.113-.382.082-.498.018a.8.8 0 0 1-.164.202h.96c.04-.064.123-.222.136-.264M11.91 10.457a2.5 2.5 0 0 1-1.95 0 .6.6 0 0 0 .22-.08c.111-.064.315-.077.411-.012a.64.64 0 0 0 .345.128.64.64 0 0 0 .345-.128c.096-.065.3-.052.412.012.068.04.153.072.218.08"
        clipRule="evenodd"
      />
      <path
        fill="#514537"
        fillRule="evenodd"
        d="M11.49 5.381c-.543-.115-1.031-.048-1.031.48v1.447c0 .16.003.18.186.224.397.095.434.105.865.207V6.251c-.337-.038-.466-.234-.466-.462 0-.22.149-.364.447-.408M10.1 9.463c-.303 0-.62-.272-.62-.79V7.383c0-.116.012-.133-.014-.16-.016-.016.017-.04.04-.063.033-.035.056-.063.01-.11-.045-.047-.025-.06.003-.089.029-.03.04-.059.013-.087s-.034-.037-.004-.068c.03-.03.017-.044-.007-.07-.025-.025-.037-.044-.005-.076.03-.032.033-.037.069-.037h.149c.035 0 .035.01.006.04-.038.04-.049.055-.006.1.043.044.04.058.013.087-.04.042-.059.07-.017.114.042.043.045.062.014.095-.032.032-.035.061 0 .097.026.028.028.044.028.093v1.315c0 .22.154.354.447.354.292 0 .392-.124.476-.206-.055.396-.213.75-.595.75M10.953 8.204c.041.013.08.074.08.14h.082a.36.36 0 0 0-.067-.197l-.005-.038c.03-.039.073-.1.072-.16-.001-.037-.044-.035-.049-.006-.004.025-.02.062-.05.075 0-.048-.026-.104-.063-.104s-.063.056-.063.104c-.03-.013-.046-.05-.05-.075-.005-.03-.047-.03-.048.007-.001.059.042.12.072.159l-.006.038a.36.36 0 0 0-.066.198h.08c0-.067.04-.128.081-.141"
        clipRule="evenodd"
      />
      <path
        fill="#514537"
        fillRule="evenodd"
        d="M10.537 8.204c.041.013.08.074.08.14h.081a.36.36 0 0 0-.066-.197.2.2 0 0 0-.005-.038c.03-.039.073-.1.071-.16 0-.037-.043-.035-.048-.006-.004.025-.02.062-.05.075 0-.048-.025-.104-.063-.104-.037 0-.063.056-.063.104-.03-.013-.046-.05-.05-.075-.005-.03-.047-.03-.048.007-.001.059.042.12.072.159a.2.2 0 0 0-.006.038.36.36 0 0 0-.066.198h.08c0-.067.04-.128.081-.141M10.122 8.204c.041.013.08.074.08.14h.081a.36.36 0 0 0-.066-.197.2.2 0 0 0-.006-.038c.03-.039.074-.1.072-.16 0-.037-.043-.035-.048-.006-.004.025-.02.062-.05.075 0-.048-.026-.104-.063-.104s-.063.056-.063.104c-.03-.013-.046-.05-.05-.075-.005-.03-.047-.03-.048.007-.001.059.042.12.072.159a.2.2 0 0 0-.006.038.36.36 0 0 0-.066.198h.08c0-.067.04-.128.081-.141M11.37 8.204c-.042.013-.081.074-.081.14h-.081c0-.056.024-.143.066-.197q.002-.02.006-.038c-.03-.039-.073-.1-.072-.16 0-.037.043-.035.048-.006.005.025.02.062.05.075 0-.048.026-.104.063-.104s.063.056.063.104c.03-.013.046-.05.05-.075.005-.03.048-.03.049.007 0 .059-.043.12-.072.159a.2.2 0 0 1 .005.038.36.36 0 0 1 .066.198h-.08c0-.067-.04-.128-.08-.141M11.784 8.204c-.04.013-.08.074-.08.14h-.08c0-.056.023-.143.065-.197l.006-.038c-.03-.039-.073-.1-.072-.16 0-.037.043-.035.049-.006.003.025.02.062.049.075 0-.048.026-.104.063-.104s.064.056.064.104c.03-.013.045-.05.05-.075.004-.03.047-.03.047.007.002.059-.042.12-.071.159l.005.038a.36.36 0 0 1 .066.198h-.08c0-.067-.04-.128-.08-.141M9.878 8.43h2.182v.107H9.878z"
        clipRule="evenodd"
      />
      <path
        fill="#514537"
        fillRule="evenodd"
        d="M11.803 9.463c.303 0 .62-.272.62-.79V7.383c0-.116-.012-.133.014-.16.015-.016-.018-.04-.04-.063-.033-.035-.056-.063-.011-.11s.026-.06-.002-.089c-.029-.03-.04-.059-.013-.087s.034-.037.004-.068c-.03-.03-.018-.044.007-.07.025-.025.037-.044.005-.076-.03-.032-.033-.037-.07-.037h-.148c-.035 0-.035.01-.006.04.038.04.049.055.006.1-.043.044-.04.058-.014.087.041.042.06.07.018.114-.042.043-.046.062-.014.095.032.032.035.061 0 .097-.027.028-.028.044-.028.093v1.315c0 .22-.154.354-.447.354-.292 0-.392-.124-.476-.206.055.396.213.75.595.75"
        clipRule="evenodd"
      />
      <path
        fill="#EEA339"
        fillRule="evenodd"
        d="M9.878 7.74v-.17l.436.17zM9.357 7.818l-.976-.136q.043-.325.159-.628l.817.335zM11.374 6.157l.173-.738q.307.077.588.229l-.56 1.108.002-.556c-.064 0-.163-.01-.203-.043M9.38 7.89l-.994-.062q-.02.325.038.648s.956.006.956 0zM9.37 7.196c-.032-.043-.013-.066.022-.09s.03-.04.013-.074-.035-.07-.003-.105c.032-.036.02-.051-.005-.077s-.027-.054-.005-.074c.023-.021.018-.036.003-.057-.015-.02-.044-.062-.018-.089l-.406-.35a2.7 2.7 0 0 0-.341.545zM10.342 7.388l-.484-.486c.069-.07.075-.082.027-.132-.053-.054-.055-.06.053-.171.036-.038.016-.064-.036-.064h-.319c-.027 0-.049.001-.069.022l-.385-.386q.221-.235.489-.408l.724 1.205zM9.839 7.461v-.256c0-.036-.003-.05-.03-.079s-.013-.041.008-.072l.458.395v.232zM10.269 6.757v-.569c0-.37.02-.554.072-.591l-.042-.178a2.8 2.8 0 0 0-.588.235zM12.06 7.74v-.17l-.437.17zM12.538 7.818l.976-.136a2.8 2.8 0 0 0-.159-.628l-.817.335zM12.538 7.89l.994-.062q.02.325-.038.648s-.956.006-.956 0zM12.507 7.196c.032-.043.012-.066-.023-.09-.034-.023-.03-.04-.012-.074s.035-.07.003-.105c-.033-.036-.02-.051.004-.077.025-.026.028-.054.005-.074-.022-.021-.017-.036-.002-.057.015-.02.044-.062.018-.089l.406-.35q.201.248.34.545zM11.623 7.388l.484-.486c-.069-.07-.075-.082-.027-.132.053-.054.054-.06-.053-.171-.036-.038-.016-.064.036-.064h.319c.027 0 .049.001.069.022l.385-.386a2.6 2.6 0 0 0-.489-.408l-.724 1.205zM12.06 7.461v-.256c0-.036.002-.05.03-.079.026-.028.013-.041-.008-.072l-.459.395v.232z"
        clipRule="evenodd"
      />
      <path
        fill="#D82332"
        fillRule="evenodd"
        d="M9.545 7.226c.017.018.025.036.025.08v1.372c0 .457.268.71.543.71.253 0 .419-.238.506-.515-.112.09-.275.118-.432.118-.18 0-.473-.126-.473-.398V7.262c0-.036-.035-.036-.17-.036M11.126 5.427c-.346-.036-.667.038-.667.526V7.25c0 .217-.016.19.161.236.322.083.359.094.749.186v-1.32c-.333-.037-.478-.263-.478-.513 0-.2.085-.387.235-.412M12.365 7.226c-.018.018-.025.036-.025.08v1.372c0 .457-.268.71-.543.71-.253 0-.42-.238-.506-.515.112.09.275.118.432.118.18 0 .473-.126.473-.398V7.262c0-.036.035-.036.169-.036"
        clipRule="evenodd"
      />
      <mask
        id="dawn-flag-PF_svg__b"
        width={6}
        height={6}
        x={8}
        y={5}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M11 10.667c1.446 0 2.619-1.194 2.619-2.667s-1.173-2.667-2.62-2.667C9.554 5.333 8.382 6.527 8.382 8S9.553 10.667 11 10.667"
          clipRule="evenodd"
        />
      </mask>
      <g mask="url(#dawn-flag-PF_svg__b)">
        <path
          fill="#064A89"
          fillRule="evenodd"
          d="M11 14.933c1.446 0 2.619-1.194 2.619-2.666 0-1.473-1.173-2.667-2.62-2.667-1.446 0-2.618 1.194-2.618 2.667S9.553 14.933 11 14.933"
          clipRule="evenodd"
        />
      </g>
    </g>
  </svg>
);
export default DawnFlagPF;
